"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarDateRangeFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var alasql = require("alasql");
var ButtonDoExportXLS_1 = require("../../../../../../shared/components/buttons/ButtonDoExportXLS");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var RepPaySystemsList = /** @class */ (function (_super) {
    __extends(RepPaySystemsList, _super);
    function RepPaySystemsList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Шлюз',
                dataIndex: _this.props.data.dk_gws_title,
                key: _this.props.data.dk_gws_title,
                width: 150,
            }, {
                title: 'Провайдер',
                dataIndex: _this.props.data.dk_prv_title,
                key: _this.props.data.dk_prv_title,
                width: 150,
            }, {
                title: 'Депозитов успешных',
                dataIndex: _this.props.data.dk_success_deposits_count,
                key: _this.props.data.dk_success_deposits_count,
                width: 150,
            }, {
                title: 'Депозитов всего',
                dataIndex: _this.props.data.dk_total_deposits_count,
                key: _this.props.data.dk_total_deposits_count,
                width: 150,
            }, {
                title: 'Процент конверсии',
                dataIndex: _this.props.data.dk_success_deposits_rate,
                key: _this.props.data.dk_success_deposits_rate,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        (record.success_deposits_rate * 100).toFixed(2),
                        " %") //{this.props.data.DATA.app_currency_symbol}
                    );
                }
            }, {
                title: 'Сумма успешных депозитов',
                dataIndex: _this.props.data.dk_success_deposits_amount,
                key: _this.props.data.dk_success_deposits_amount,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        Intl.NumberFormat('en-US').format(record.success_deposits_amount),
                        " ",
                        _this.props.data.DATA.app_currency_symbol));
                }
            }, {
                title: 'Сумма всего депозитов',
                dataIndex: _this.props.data.dk_total_deposits_amount,
                key: _this.props.data.dk_total_deposits_amount,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        Intl.NumberFormat('en-US').format(record.total_deposits_amount),
                        " ",
                        _this.props.data.DATA.app_currency_symbol));
                }
            }, {
                title: 'Средняя сумма депозита',
                dataIndex: _this.props.data.dk_avg_deposits_amount,
                key: _this.props.data.dk_avg_deposits_amount,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        Intl.NumberFormat('en-US').format(record.avg_deposits_amount),
                        " ",
                        _this.props.data.DATA.app_currency_symbol));
                }
            }
        ];
        return _this;
    }
    RepPaySystemsList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    RepPaySystemsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data,
                totalRows: data.total_count
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat(),
            is_skip_zero_partners: true,
            selected_currency_id: this.props.state.getCurrencyId()
        }, function () {
            //alert(`${this.props.state.getCurrencyId()} <-> ${this.props.state.getOrgId()}`);
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    RepPaySystemsList.prototype.getDefaultAppCurrencyId = function () {
        if (this.props.availCurrency.length > 0) {
            return this.props.availCurrency[0].key;
        }
        else {
            return 0;
        }
    };
    RepPaySystemsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    RepPaySystemsList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    RepPaySystemsList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadData({
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            brands_id_list: this.props.brandsList,
            all_brands: this.props.allBrands,
            app_currency_id: this.state.selected_currency_id,
            limit: this.state.pageSize,
            offset: this.getDataOffset()
            //    skip_zero_partners: this.state.is_skip_zero_partners
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    //private getRealBrandProfit(record: IReportPlayerProfitListItem): string {
    //    let tmp = record.total_brand_ggr_amount - record.total_partner_profit_amount;
    //    return tmp.toFixed(2);
    //    }
    RepPaySystemsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
    };
    RepPaySystemsList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    RepPaySystemsList.prototype.onOfferFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onOfferFilterChanged) {
            this.props.onOfferFilterChanged(allBrands, BrandId, Action);
        }
    };
    RepPaySystemsList.prototype.doExportPlayers = function () {
        var _this = this;
        this.props.dlgExportList
            .clearFields()
            .SetDialogTitle("Экспорт отчета")
            .SetOnYesClick(function (exportFormat) {
            _this.props.data.doExportObjectArray({
                from_year: _this.state.dtFrom.get('year'),
                from_month: _this.state.dtFrom.get('month') + 1,
                from_day: _this.state.dtFrom.get('date'),
                to_year: _this.state.dtTo.get('year'),
                to_month: _this.state.dtTo.get('month') + 1,
                to_day: _this.state.dtTo.get('date'),
                brands_id_list: _this.props.brandsList,
                all_brands: _this.props.allBrands,
                app_currency_id: _this.state.selected_currency_id,
                limit: 100,
                offset: 0,
            }, function (data) {
                if (exportFormat === "XLSX") {
                    var opts = [{ sheetid: 'Exported report data', header: true }];
                    var result = alasql('SELECT * INTO XLSX("exported_report_data.xlsx",?) FROM ?', [opts, [data]]);
                }
                if (exportFormat === "CSV") {
                    var result = alasql('SELECT * INTO CSV("exported_report_data.csv", {headers:true}) FROM ?', [data]);
                }
                if (exportFormat === "JSON") {
                    var result = alasql('SELECT * INTO JSON("exported_report_data.json", {headers:false}) FROM ?', [data]);
                }
                if (exportFormat === "TXT") {
                    var result = alasql('SELECT * INTO TAB("exported_report_data.txt", {headers:true}) FROM ?', [data]);
                }
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 ",
                    React.createElement("b", null,
                        "[",
                        exportFormat,
                        "]"),
                    " \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D !"));
            });
        }).Show();
    };
    RepPaySystemsList.prototype.onCheckBoxChecked = function (checked) {
        this.setState({ is_skip_zero_partners: checked });
    };
    RepPaySystemsList.prototype.getCurrencyISO = function (id) {
        for (var i = 0; i < this.props.availCurrency.length; i++) {
            if (this.props.availCurrency[i].key == id) {
                return this.props.availCurrency[i].value;
            }
        }
        return "";
    };
    RepPaySystemsList.prototype.getCurrencyValue = function () {
        if (this.state.selected_currency_id === 0) {
            return undefined;
        }
        else {
            return {
                key: this.state.selected_currency_id.toString(),
                label: this.getCurrencyISO(this.state.selected_currency_id)
            };
        }
    };
    RepPaySystemsList.prototype.getSelectCurrencyItems = function () {
        var _ret = [];
        for (var i = 0; i < this.props.availCurrency.length; i++) {
            _ret.push(React.createElement(antd_1.Select.Option, { key: "" + i, value: "" + this.props.availCurrency[i].key }, this.props.availCurrency[i].value));
        }
        return _ret;
    };
    RepPaySystemsList.prototype.onCurrencyValueChange = function (value, option) {
        this.setState({
            selected_currency_id: parseInt(value.key)
        });
    };
    RepPaySystemsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
            _this.loadData(_this.props);
            // if (this.props.onPageConfigChanged) {
            //   this.props.onPageConfigChanged(_page, _PageSize);
            // }
        });
    };
    RepPaySystemsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ButtonDoExportXLS_1.default, { hint: "Экспорт списка", onClick: function () { _this.doExportPlayers(); } }),
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) }),
                React.createElement("div", { style: { marginLeft: "5px", marginRight: "5px", whiteSpace: "nowrap" } }, "\u0412\u0430\u043B\u044E\u0442\u0430 \u043E\u0442\u0447\u0435\u0442\u0430"),
                React.createElement(antd_1.Select, { style: { width: "100px", marginLeft: "5px", marginRight: "2px" }, showSearch: true, 
                    // placeholder={this.props.captions.placeholderYear}
                    optionFilterProp: "children", filterOption: function (input, option) {
                        return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                    }, onChange: this.onCurrencyValueChange.bind(this), labelInValue: true, value: this.getCurrencyValue() }, this.getSelectCurrencyItems()),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onOfferFilterChanged.bind(this) })),
            React.createElement("div", { style: { overflowX: "auto" } },
                React.createElement(antd_1.Table, { locale: {
                        filterTitle: 'Поиск',
                        filterConfirm: 'Да',
                        filterReset: 'Сброс',
                        emptyText: 'Нет данных',
                    }, bordered: true, columns: this.columns, dataSource: this.state.data.data, pagination: {
                        pageSize: this.state.pageSize,
                        showSizeChanger: true,
                        current: this.state.pageNum,
                        total: this.state.totalRows,
                        position: "top",
                        onChange: this.onPageChanged.bind(this),
                        onShowSizeChange: this.onPageChanged.bind(this),
                        pageSizeOptions: this.props.state.UITablePageSizeOptions,
                        showQuickJumper: true,
                    }, style: { overflowX: "clip", minWidth: "2100px" }, scroll: { y: "calc( 100vh - 375px )", x: false } }),
                React.createElement(antd_1.Table, { locale: {
                        filterTitle: 'Поиск',
                        filterConfirm: 'Да',
                        filterReset: 'Сброс',
                        emptyText: 'Нет данных',
                    }, bordered: true, columns: this.columns, dataSource: this.state.data.data_total, pagination: false, showHeader: false, style: { overflowX: "clip", minWidth: "2100px" }, rowClassName: function (record) {
                        if (record.total) {
                            return "summary-table-row";
                        }
                        else {
                            return "";
                        }
                    }, scroll: { y: "75px" } }))));
    };
    return RepPaySystemsList;
}(React.Component));
exports.default = RepPaySystemsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/rep_paysystems/ui/component/RepPaySystems.tsx
// module id = 2546
// module chunks = 0